import React from "react";
// import image from  '../../assets/images/RandDImages/RD-Info-Image.png'
import image from '../../assets/images/RandDImages/researchdevelopment.jpg'


function RandDContent() {
  return (
    <div>
      <section className="contact-page py-50 rpy-100">
        <div className="container">
          <div className="row">
            <div className="col-lg-5  d-flex justify-center align-items-center">
              <img src={image} alt="R&D "/>

            </div>
            <div className="col-lg-7">
              <div className="team-profile-content ml-10 rml-0 wow fadeInRight delay-0-2s">
                <p className="about-text mt-20">
                  At Elena Geo, Research and Development (R&D) team plays a
                  pivotal role in driving innovation in the field of Global
                  Navigation Satellite Systems (GNSS), with a special emphasis
                  on India’s indigenous NavIC system. With a strong focus on
                  precision, reliability, and indigenous development, our team
                  comprises skilled professionals dedicated to creating
                  impactful navigation and positioning solutions. Our R&D
                  efforts are deeply rooted in solving complex technical
                  challenges—ranging from signal acquisition and processing to
                  error modeling, real-time positioning accuracy, and multi-GNSS
                  integration. We invest heavily in prototyping, simulation, and
                  rigorous field testing to validate the performance and
                  resilience of our technologies across diverse use cases such
                  as defense, disaster management, transportation, and
                  infrastructure.
                </p>
                <p className="about-text mt-20">
                  We actively collaborate with leading academic
                  institutions to exchange knowledge, undertake joint research
                  initiatives, and stay abreast of emerging trends in satellite
                  technology.
                  These collaborations help us blend academic insight with
                  practical application, enabling Elena Geo to deliver
                  cutting-edge GNSS solutions that meet the evolving needs of
                  various sectors. Through continuous innovation and a commitment to
                  excellence, we aim to contribute meaningfully to the growth of
                  indigenous satellite navigation capabilities and strengthen
                  India’s position in the global GNSS ecosystem, with NavIC at
                  the core of our mission.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default RandDContent;
